module.exports = __webpack_public_path__ + "static/media/audiowave.4a4dc33d.png";